import { cn } from "@/modern/utils";

/** Outer padding for the workflow strip row. */
export const marketingStackStripClassName = "shrink-0 px-3 pt-1.5 pb-1";

/** Root wrapper for marketing stack full-page views. */
export const marketingStackPageClassName = "flex flex-col h-full min-h-0";

/** Inset around main content below the workflow strip (matches Context page). */
export const marketingStackContentInsetClassName =
  "flex flex-1 min-h-0 flex-col px-3 pb-1.5";

/** Bordered card shell for page body content. */
export function marketingStackCardClassName(className?: string) {
  return cn(
    "flex flex-1 min-h-0 flex-col overflow-hidden rounded-lg border border-border bg-card",
    className,
  );
}
